import React from 'react';
import './App.css';
import NavBar from './components/navbar'
import About from './components/about'
import Project from './components/project'
import Publications from './components/publications'
import CV from './components/cv'
import Footer from './components/footer'

function App() {
    return (
        <div className="App">
            <a className="skip-link" href="#about">Skip to content</a>
            <NavBar />
            <main className="page" id="main">
                <div className="garden">
                    <About />
                    <Project />
                    <Publications />
                    <CV />
                    <Footer />
                </div>
            </main>
        </div>
    );
}

export default App;
